module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-60x60-a6ba9ba2dea50e9abab292c7617c3635.png";